import { Component, OnInit } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
  item:any;
}

@Component({
  selector: 'app-contactslist',
  templateUrl: './contactslist.component.html',
  styleUrls: ['./contactslist.component.css']
})

export class ContactslistComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  item:any;
  result: any = { result: false, RtnItem: {} };
  cols: any;
  data: any;
  selected_row: any;
  selected_index = 0;
  totalCount = 0;
  serviceName = '';
  loading = false;
  filterModel: any = {};
  isEnable = false;
  dataKey: string;
  data_Model: any;
  enable_Search = true;

  constructor(public dialogService: DialogService, private ps: PosService) {
    super(dialogService);
  }

  ngOnInit() {
    this.cols = this.item.cols;
    for (const i of this.cols) {
      this.filterModel[i.field] = '';
    }

    this.data = this.item.data;
    this.totalCount = this.item.totalCount;
    this.serviceName = this.item.serviceName;
    if (this.item.model) {
      this.data_Model = this.item.model;
    }
   this.enable_Search = this.item.enable_Search;
    this.isEnable = true;
    this.dataKey = this.cols[0].field;
    this.searchItem(0);
  }

  onLazyLoad(e) {
    this.searchItem(e.Start);
  }

  FilterKeyDown(e, filed) {
    if (e.keyCode == 13) {
      this.searchItem();
    } else if (e.keyCode == 40) {
      if (this.data.length != 0) {
        this.selected_row = this.data[0];
        this.selected_index = 0;
        document.getElementById('type').focus();
      }
    }
  }

  onRowSelect(e) {
    this.selected_index = e.index;
    this.selected_row = e.data;
    document.getElementById('type').focus();
  }

  onRowDblClick(e, data, ix) {
    this.selected_index = ix;
    this.selected_row = data;
    this.Success_Close();
  }

  keyevent(e) {
    if (e.keyCode == 40) {
      let a = 13;
      if (this.data.length < 14) {
        a = this.data.length - 1;
      }
      if (this.selected_index < a) {
        this.selected_index++;
      } else {
      }
      this.selected_row = this.data[this.selected_index];
    } else if (e.keyCode == 38) {
      if (this.selected_index > 0) {
        this.selected_index--;
      }
      this.selected_row = this.data[this.selected_index];
    } else if (e.keyCode == 13) {
      this.Success_Close();
    }
  }

  Success_Close() {
    this.result.result = true;
    this.result.RtnItem = this.selected_row;
    this.close();
  }

  searchContact(Start = 0) {
    const m = {
      Contact: this.filterModel,
      Filter: {
        Start: Start,
        FiterText: '',
        Limit: 13,
        LocationId: 1
      }
    };
    this.loading = true;
    this.ps.GetPOSContactSearch(m).subscribe(res => {
      if (res.Success) {
        this.totalCount = res.total;
        this.data = res.data;
        this.loading = false;
      }
    });
  }

  SalesHistory(Start = 0) {
    const m = {
      PhoneNo: this.data_Model,
      RequestedList: {
        Start: Start,
        FiterText: '',
        Limit: 13,
        ItemTypeId: 1,
        CAType: 1
      }
    };
    this.loading = true;
    this.ps.GetSalesHistoryByContacts(m).subscribe(res => {
      if (res.Success) {
        this.totalCount = res.total;
        this.data = res.data;
        this.loading = false;
      }
    });
  }

  searchItem(Start = 0) {
    switch (this.serviceName) {
      case 'GetPOSContactSearch':
        this.searchContact(Start);
        break;
      case 'GetSalesHistoryByContacts':
        this.SalesHistory(Start);
        break;
      default:
        this.searchContact(Start);
        break;
    }
  }

}
